<script>
  import { useForm, inertia } from '@inertiajs/svelte';
  import AuthLayout from '../../components/AuthLayout.svelte';
  import Field from '../../components/ui/Field.svelte';
  import Button from '../../components/ui/Button.svelte';

  const form = useForm({ email: '', password: '' });

  let clientErrors = $state({});

  function validate() {
    clientErrors = {};
    if (!form.email.trim()) clientErrors.email = 'Email is required.';
    if (!form.password) clientErrors.password = 'Password is required.';
    else if (form.password.length < 8) clientErrors.password = 'Password must be at least 8 characters.';
    return Object.keys(clientErrors).length === 0;
  }

  function submit() {
    if (!validate()) return;
    // Rodauth handles POST /auth/create-account; redirects to / on success.
    form.post('/auth/create-account');
  }
</script>

<AuthLayout title="Create your account">
  <form onsubmit={(e) => { e.preventDefault(); submit(); }} class="flex flex-col gap-4" novalidate>
    <Field label="Email" id="email" error={clientErrors.email || form.errors.email}>
      {#snippet children(describedBy)}
        <input id="email" type="email" class="input" bind:value={form.email} autocomplete="email" aria-describedby={describedBy} />
      {/snippet}
    </Field>
    <Field label="Password" id="password" error={clientErrors.password || form.errors.password}>
      {#snippet children(describedBy)}
        <input id="password" type="password" class="input" bind:value={form.password} autocomplete="new-password" minlength="8" aria-describedby={describedBy} />
      {/snippet}
      {#snippet hint()}
        <span class="text-xs text-secondary-400">At least 8 characters.</span>
      {/snippet}
    </Field>
    <Button type="submit" disabled={form.processing}>
      {form.processing ? 'Creating…' : 'Create account'}
    </Button>
  </form>

  <p class="text-sm text-secondary-500 text-center mt-6">
    Already have an account? <a use:inertia href="/login" class="text-primary-600 font-medium">Sign in</a>
  </p>
</AuthLayout>
